import React from 'react';

/**
 * Shared GO4NIHONGO logo — red badge + wordmark.
 * size: 'sm' | 'md' (default) | 'lg'
 */
export default function Logo({ size = 'md', onClick, style }) {
  const sizes = {
    sm: { badge: 24, text: 13, radius: 6, shadow: '0 2px 8px rgba(220,50,50,0.35)' },
    md: { badge: 30, text: 16, radius: 8, shadow: '0 3px 12px rgba(220,50,50,0.40)' },
    lg: { badge: 38, text: 20, radius: 10, shadow: '0 4px 16px rgba(220,50,50,0.45)' },
  };
  const s = sizes[size] || sizes.md;

  return (
    <div
      onClick={onClick}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: s.badge * 0.3,
        cursor: onClick ? 'pointer' : 'default',
        textDecoration: 'none',
        ...style,
      }}
    >
      {/* Red badge */}
      <div style={{
        width: s.badge,
        height: s.badge,
        borderRadius: s.radius,
        background: 'linear-gradient(135deg, #f43f5e 0%, #be123c 100%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#fff',
        fontWeight: 900,
        fontSize: s.badge * 0.48,
        letterSpacing: '-0.02em',
        flexShrink: 0,
        boxShadow: s.shadow,
      }}>
        G
      </div>

      {/* Wordmark */}
      <span style={{
        fontFamily: "'Sora','Inter',sans-serif",
        fontWeight: 800,
        fontSize: s.text,
        letterSpacing: '-0.03em',
        color: 'var(--text-primary, #ffffff)',
        lineHeight: 1,
        whiteSpace: 'nowrap',
      }}>
        GO4<span style={{ color: '#f43f5e' }}>NIHONGO</span>
      </span>
    </div>
  );
}
